import { Controller } from "@hotwired/stimulus";

// A row of a list the user can dismiss (the form inside it saves that). It
// fades out; the last row of a panel takes the whole panel with it.
export default class extends Controller {
  dismiss() {
    const panel = this.element.closest(".panel");
    const visibleRows = panel
      ? Array.from(panel.querySelectorAll("tr.event")).filter((row) => row.offsetParent !== null)
      : [];
    const gone = panel && visibleRows.length <= 1 ? panel : this.element;
    // The element stays in place while the request is sent from its form.
    gone.animate([{opacity: 1}, {opacity: 0}], {duration: 400, fill: "forwards"}).finished.then(() => gone.remove());
  }
}
